import "../../resources/less/Constellation/CDOSunset.less";

class CDOSunset {
  constructor() {}
}

$(window).on("load", () => {
  new CDOSunset();
});
